import { memo } from 'react';
import type { SalesMetrics } from '@/store/seller';

interface SalesMetricCardProps {
  salesMetrics: SalesMetrics | null;
  restaurantName?: string;
  loading?: boolean;
}

export const SalesMetricCard = memo(function SalesMetricCard({ 
  salesMetrics,
  restaurantName,
  loading = false 
}: SalesMetricCardProps) {
  if (loading) {
    return (
      <div className="bg-white rounded-lg p-4 mb-4">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-20 mb-2"></div>
          <div className="h-6 bg-gray-200 rounded w-32 mb-1"></div>
          <div className="h-6 bg-gray-200 rounded w-24"></div>
        </div>
      </div>
    );
  }

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('ko-KR').format(amount);
  };

  return (
    <div className="bg-white rounded-lg p-4 -mb-2">
      {restaurantName && (
        <h1 className="text-xl font-bold text-gray-900 mb-3 text-left">
          {restaurantName}
        </h1>
      )}
      <h2 className="text-lg font-bold text-gray-800 mb-3">
        {salesMetrics?.currentMonth || `${new Date().getFullYear()}년 ${new Date().getMonth() + 1}월`}
      </h2>
      
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-gray-600">총 매출</span>
          <span className="text-xl font-bold text-green-600">
            {formatCurrency(salesMetrics?.monthlyRevenue || 0)}원
          </span>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-gray-600">판매 건수</span>
          <span className="text-lg font-semibold text-gray-800">
            {salesMetrics?.monthlySalesCount || 0}건
          </span>
        </div>
      </div>
    </div>
  );
});